import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'change-bag-seal',
	components: {
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoading: false,
			isBagData: false,
			reason: '',
			oldbagsealno: '',
			newbagsealno: '',
			bagDetails: [],
			hubId: '',
			hubName: '',
			createdBy: '',
			IsDisable: false
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubId = userdetail[0].HubId[0];
		this.createdBy = userdetail[0].email;
		this.getHubName(userdetail[0].HubId);
	},
	methods: {
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		showBagDetails() {
			if (this.oldbagsealno == '') {
				this.$validator.validate('OldBagSealNo')
				return false;
			} else {
				this.bagDetails = []
				this.isBagData = true
				this.isLoading = true
				axios({
						method: 'GET',
						url: apiUrl.api_url_hubops + 'getBagDetailsForCLTCRM?bagno=' + this.oldbagsealno.trim(),
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						this.isLoading = false
						this.IsDisable = false
						if (result.data.ResultCode == 100) {
							this.bagDetails = result.data.ResponseData.BagDetails
						} else {
							this.IsDisable = true
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},
		updateBagSealNumber() {
			this.input = ({
				"CurrentHubID": this.hubId,
				"OldBagSealNo": this.oldbagsealno.trim(),
				"NewBagSealNo": this.newbagsealno.trim(),
				"SealChangedReason": this.reason,
				"LastModifiedBy": this.createdBy,
				"CurrentHubName": this.hubName,
				"statusMarkedFrom": "WEB"
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'updateBagSealNo',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						//  this.$alertify.success(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "success");
						this.resetForm()
					} else {
						//this.$alertify.error(result.data.ReturnMessage);
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					console.error(error)
				})
		},
		resetForm() {
			this.reason = ''
			this.oldbagsealno = ''
			this.newbagsealno = ''
			this.isBagData = false
			this.IsDisable = false
			this.$validator.reset()
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					this.updateBagSealNumber()
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/changeBagSeal/changeBagSeal.js